import { __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import { Button } from '../Button/Button.js';
import { useDay } from './hooks/useDay.js';

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = React.useRef(null);
    var day = useDay(props.date, props.displayMonth, buttonRef);
    var buttonProps = day.buttonProps, nonInteractiveProps = day.nonInteractiveProps;
    if (!buttonProps && !nonInteractiveProps) {
        return React.createElement(React.Fragment, null);
    }
    if (nonInteractiveProps) {
        return React.createElement("div", __assign({}, nonInteractiveProps));
    }
    return React.createElement(Button, __assign({ ref: buttonRef }, buttonProps));
}

export { Day };
//# sourceMappingURL=Day.js.map
